import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

import { SedsTimerComponent } from './seds-timer.component';

@NgModule({
  declarations: [SedsTimerComponent],
  imports: [CommonModule, MatIconModule],
  exports: [SedsTimerComponent],
})
export class SedsTimerModule {}
